import React, { useMemo, useState } from 'react';
import { useConnectModal } from '@rainbow-me/rainbowkit';
import { useAccount, useDisconnect } from 'wagmi';
import { wagmiTokenGateway } from '../../../adapters/wallet/wagmiAdapters';
import { currentDemo, Demo } from '../../../adapters/demo/demo';
import { demoGateway } from '../../../adapters/demo/fakes';
import { GovernanceScreen } from './GovernanceScreen';

/** Composition root of /governance: the real wallet and contracts, or the local demo fakes on this machine. */

const DEMO_ADDRESS = '0x7a3B9c2D4e5F60718293A4b5C6d7E8f901234aBc';

const LiveGovernance: React.FC = () => {
  const { address } = useAccount();
  const { openConnectModal } = useConnectModal();
  const { disconnect } = useDisconnect();
  const ports = useMemo(
    () => ({
      address: address ?? null,
      gateway: address ? wagmiTokenGateway(address) : null,
      connect: () => openConnectModal?.(),
      disconnect: () => disconnect(),
    }),
    [address, openConnectModal, disconnect]
  );
  return <GovernanceScreen ports={ports} />;
};

const DemoGovernance: React.FC<{ demo: Demo }> = ({ demo }) => {
  const [on, setOn] = useState(demo !== 'off');
  const gateway = useMemo(() => demoGateway(demo === 'off' ? 'on' : demo), [demo]);
  const ports = useMemo(
    () => ({ address: on ? DEMO_ADDRESS : null, gateway: on ? gateway : null, connect: () => setOn(true), disconnect: () => setOn(false) }),
    [gateway, on]
  );
  return <GovernanceScreen ports={ports} />;
};

const GovernancePage: React.FC = () => {
  const demo = currentDemo();
  return demo ? <DemoGovernance demo={demo} /> : <LiveGovernance />;
};

export default GovernancePage;
